import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import Spiner from "../../../../../common/Spiner";

import {renderError, toPascalCase} from "../../../../../../services/helpers";
import validator from "../../../../../../services/DataValidator";
import api from "../../../../../../api";
import { hideModal, showModal } from "../../../../../../actions/modals";

class RegisterAuditEditModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            ID: null,

            data: {
                fuelList: [],
                employeeList: []
            },

            fuelType: '',
            employee: '',

            callback: () => {},

            validation: []
        };
    }

    async componentDidMount(){

        let employeeList = await api.apiGetEmployeeData();
        employeeList.data.value = toPascalCase(employeeList.data.value);

        let employeeListArray = employeeList.data.value.map((item, i) => {
            return { value: item.ID, label: item.Name };
        });

        let fuelList = await api.apiGetFuelList();

        fuelList.data.value = toPascalCase(fuelList.data.value)

        let fuelListArray = fuelList.data.value.map((item, i) => {
            return { value: item.ID, label: item.FuelName };
        });

        this.setState({
            data: {
                employeeList: employeeListArray,
                fuelList: fuelListArray
            },

            ID: this.props.propsData.ID,
            employee: {
                value: this.props.propsData.Employee.ID, label: `${this.props.propsData.Employee.Surname} ${this.props.propsData.Employee.Name} ${this.props.propsData.Employee.Patronymic}`
            },
            fuelType: this.props.propsData.AuditFuel.Barrel.TypeFuel === null ? '' : {
                value: this.props.propsData.AuditFuel.Barrel.TypeFuel.ID, label: this.props.propsData.AuditFuel.Barrel.TypeFuel.FuelName
            },

            callback: this.props.propsData.callback
        });
    }

    handleEmployee = (selectedOption) => {
        this.setState({
            employee: selectedOption
        });
    };

    handleFuelType = (selectedOption) => {
        this.setState({
            fuelType: selectedOption
        });
    };

    handleSave = () => {

        let validationResult = validator.arrayValidation([
            { id: 'fuelType', name: 'fuel type', type: 'EMPTY', value: this.state.fuelType },
            { id: 'employee', name: 'employee', type: 'EMPTY', value: this.state.employee },
        ]);

        if(validationResult.state == 'success'){
            this.setState({ loading: true });
            let dataToSend = {
                ID: +this.state.ID,
                AuditFuelID: +this.state.fuelType.value,
                EmployeeID: +this.state.employee.value
            };

            api.apiEditRegisterAudit(dataToSend).then(res => {
                this.setState({ loading: false });
                if(res.status == 204){
                    this.props.dispatchHideModal();
                    this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати запис', description: 'Запис був успішно відредагований', type: true })
                    this.state.callback();
                } else {
                    this.props.dispatchHideModal();
                    this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати запис', description: 'Запис не був відредагований. Зверніться до адміністратора', type: false })
                }
            }).catch(error => {
                this.setState({ loading: false });
                this.props.dispatchHideModal();
                this.props.dispatchShowModal('INFO_MODAL', { title: 'Редагувати запис', description: error.response.data.message, type: false });
            });
        }

        this.setState({
            validation: validationResult.errorArr
        });
    };

    render(){
        return (
            <div>
                <div className="modal-header">
                    <button type="button" className="close" onClick={this.props.closeModal}>
                        <i className="fa fa-times"></i>
                    </button>
                    <h5 className="modal-title">Редагувати запис</h5>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Тип палива</h5>
                                <div>
                                    <Select
                                        value={this.state.fuelType}
                                        onChange={this.handleFuelType}
                                        options={this.state.data.fuelList}
                                    />
                                    <div className="form-group-error">
                                        { renderError('fuelType', this.state.validation) }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <div className="modal__row">
                                <h5>Працівник</h5>
                                <div>
                                    <Select
                                        value={this.state.employee}
                                        onChange={this.handleEmployee}
                                        options={this.state.data.employeeList}
                                    />
                                    <div className="form-group-error">
                                        { renderError('employee', this.state.validation) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="row">
                        <div className="col-lg-12">
                            <button
                                disabled={this.state.loading}
                                onClick={this.handleSave}
                                type="button"
                                className="btn btn-primary"
                            >
                                {
                                    !this.state.loading
                                        ? <span>Зберегти</span>
                                        : <span>Зберігаємо</span>
                                }
                                {!this.state.loading ? null : <Spiner />}
                            </button>
                            <button onClick={this.props.closeModal} type="button" className="btn btn-secondary">Відмінити</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        typeTerm: typeof state.user.data.typeTermList != "undefined" ? state.user.data.typeTermList: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchShowModal: (type, data) => dispatch(showModal(type, data)),
        dispatchHideModal: (type, data) => dispatch(hideModal(type, data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAuditEditModal);
